module.exports = __webpack_public_path__ + "static/media/Whitelist_Device.dffa07c8.svg";